import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callSimplypayApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';

const SimplyPay = () => {
  const { translate } = useLanguage();
  const [loadingSimplyPayInfo, setLoadingSimplyPayInfo] = useState(false);
  const [infoSimplyPay, setInfoSimplyPay] = useState(
    sessionStorage.getItem("simplypay_info")
      ? JSON.parse(sessionStorage.getItem("simplypay_info"))
      : {}
  );
  const [waitingPayment, setWaitingPayment] = useState(
    sessionStorage.getItem("waiting_payment")
      ? JSON.parse(sessionStorage.getItem("waiting_payment"))
      : false
  );
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    translate();
  }, [translate]);

  const callSimplyPay = () => {
    setLoadingSimplyPayInfo(true);
    // If no simplypay info is stored yet, call the API
    if (Object.keys(infoSimplyPay).length === 0) {
      callSimplypayApi(sessionStorage.getItem("order_no"))
        .then((res) => {
          if (res !== undefined) {
            setInfoSimplyPay(res);
            sessionStorage.setItem("simplypay_info", JSON.stringify(res));
            setLoadingSimplyPayInfo(false);
          } else {
            setErrorMsg("Please, talk with the Administrator.");
            setLoadingSimplyPayInfo(false);
            setIsError(true);
          }
        })
        .catch((err) => {
          console.log(err.toString());
          setErrorMsg(
            err.response?.data?.message
              ? err.response?.data?.message
              : "Internal server error"
          );
          setIsError(true);
        })
        .finally(() => {
          setLoadingSimplyPayInfo(false);
          translate();
        });
    }
  };

  useEffect(() => {
    let timeout;
    function checkPayment() {
      timeout = setTimeout(() => {
        getDeposit(sessionStorage.getItem("order_no"))
          .then((res) => {
            if (res.status.toLowerCase() === "paid") {
              setWaitingPayment(false);
              sessionStorage.setItem("waiting_payment", false);
              window.location.replace(getURLBackToPanel());
            } else {
              checkPayment();
            }
          })
          .catch((err) => {
            alert(err);
            checkPayment();
          });
      }, 30000);
    }
    if (waitingPayment) {
      sessionStorage.setItem("waiting_payment", true);
      checkPayment();
    }
    return () => clearTimeout(timeout);
  }, [loadingSimplyPayInfo]);

  useEffect(() => {
    if (Object.keys(infoSimplyPay).length === 0) {
      callSimplyPay();
    }
    return () => {
      const iframe = document.getElementById("simplypay_frame");
      if (iframe) {
        iframe.removeEventListener("load", () => {});
      }
    };
  }, []);

  const [loading, setLoading] = useState(true);
  const handleLoad = () => {
    setLoading(false);
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type === "redirected") {
        const redirectedUrl = event.data.url;
        window.location.href = redirectedUrl;
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <>
      {loadingSimplyPayInfo && (
        <div className="group-pix-content">
          <div className="pix-container">
            <div className="grup-crypto-opt">
              <div className="msg-pix">
                <img src={Loading} alt="loading" width="30px" height="30px" />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="">
        {Object.keys(infoSimplyPay).length !== 0 ? (
          <>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* {loading && (
                  <div className="loader">
                    <img src={Loading} alt="loading" width="30px" height="30px" />
                  </div>
                )} */}
              </div>

              <iframe
                id="simplypay_frame"
                src={infoSimplyPay.params.paymentLink}
                title="SimplyPay Payment"
                width="100%"
                height="800px"
                onLoad={handleLoad}
                style={{ display: loading ? "none" : "block" }}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        {isError && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h4>{errorMsg}</h4>
          </div>
        )}
      </div>
    </>
  );
};

export default SimplyPay;
